export default __webpack_public_path__ + "static/vimeoHint-9f955faa2bbc4f607ec81a9dbeb134cd.jpg";